const mockData = new Map<string, unknown>();

export const getMock = (key: string): unknown => mockData.get(key);

export const registerMock = (key: string, data: unknown): void => {
  mockData.set(key, data);
};
